import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class WPEngine extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 109 109"
        {...otherProps}
      >
        <path
          d="M36.6821 108.096H71.4111V81.6761L63.1041 73.3682H44.9871L36.6871 81.6742L36.6821 108.096Z"
          fill="white"
        />
        <path
          d="M81.6718 36.6841L73.3628 44.9931V63.1081L81.6718 71.4141H108.09V36.6841H81.6718Z"
          fill="white"
        />
        <path
          d="M71.4131 0H36.6821V26.424L44.9881 34.73H63.1031L71.4111 26.424L71.4131 0Z"
          fill="white"
        />
        <path
          d="M108.089 108.096V81.6762L99.7892 73.3672H73.3652V108.095L108.089 108.096Z"
          fill="white"
        />
        <path
          d="M8.30502 0.000976562L-0.000976562 8.30998V34.729H34.728V0.000976562H8.30502Z"
          fill="white"
        />
        <path
          d="M73.3652 0V26.424L81.6742 34.73H108.089V0H73.3652Z"
          fill="white"
        />
        <path
          d="M54.0468 59.0232C53.0628 59.0232 52.101 58.7315 51.2828 58.1848C50.4647 57.6381 49.827 56.8612 49.4505 55.9521C49.0739 55.043 48.9754 54.0427 49.1674 53.0776C49.3593 52.1126 49.8331 51.2261 50.5289 50.5304C51.2247 49.8346 52.1111 49.3608 53.0762 49.1688C54.0412 48.9769 55.0416 49.0754 55.9506 49.4519C56.8597 49.8285 57.6367 50.4661 58.1833 51.2843C58.73 52.1024 59.0218 53.0643 59.0218 54.0482C59.0218 54.7016 58.8931 55.3485 58.6431 55.9521C58.3931 56.5557 58.0266 57.1041 57.5646 57.5661C57.1026 58.0281 56.5542 58.3945 55.9506 58.6445C55.347 58.8946 54.7001 59.0232 54.0468 59.0232"
          fill="white"
        />
        <path
          d="M34.729 36.6841H0V71.4141H26.421L34.729 63.1081V36.6841Z"
          fill="white"
        />
        <path
          d="M34.729 81.6732L26.421 73.3652H0V108.095H26.421L34.729 99.7952V81.6732Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default WPEngine;
